import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPencil } from '@fortawesome/pro-light-svg-icons'

import {
  Box, Link, ListItem, Text,
} from '@domain-group/suit-theme'

import usePublicationBooking from '@hooks/usePublicationBooking'
import usePublicationBookingItems from '@hooks/usePublicationBookingItems'
import useStatus from '@hooks/useStatus'

import { getBookingConfirmationId } from '@functions/publicationBooking'

import AuthenticatedDownload from '@components/AuthenticatedDownload'
import ApprovedArtworksBadge from './components/ApprovedArtworksBadge'
import CampaignsBadge from './components/CampaignsBadge'
import StatusCheckbox from './components/StatusCheckbox'

const BookingListItem = (props: { bookingId: number }) => {
  const { bookingId } = props

  const {
    callbacks: {
      managePublicationBooking,
    },
    publicationBooking,
    publicationProduct,
    urls: { downloadPDFUrl },
  } = usePublicationBooking({ id: bookingId })

  const {
    artwork_counts: artworkCounts,
    dates,
  } = publicationBooking || {}

  const publicationBookingItemsPayload = usePublicationBookingItems({ filters: { publication_booking_id: bookingId } })
  const { filteredPublicationBookingItems } = publicationBookingItemsPayload

  const bookingConfirmationId = getBookingConfirmationId({
    publicationBooking,
    publicationBookingItems: filteredPublicationBookingItems,
  })

  const { status } = useStatus({ id: publicationBooking.status_id })

  return (
    <ListItem
      borderColor="lineColor"
      boxProps={{ borderBottom: '1px dashed', minHeight: '51px' }}
      disableHover
      // @ts-expect-error TS2322
      fontSize="small"
      padding="large"

    >
      <Box paddingX="large">
        <Box alignItems="center" fontSize="small" maxWidth="60%">
          {/*
           // @ts-expect-error TS2739 */}
          <StatusCheckbox dates={dates} status={status} />

          <Text
            marginLeft="large"
            variant="ellipsis"
          >
            <AuthenticatedDownload key="bookingForm">
              <Link href={downloadPDFUrl}>
                {/*
                 // @ts-expect-error TS2339 */}
                {`#${bookingId} - ${publicationProduct.title || 'Deleted Product'}`}
              </Link>
            </AuthenticatedDownload>
          </Text>
        </Box>

        <Box alignItems="center" display={['none', 'flex']} fontSize="small" maxWidth="40%" justifyContent="flex-end">
          <Text
            color="bodyFontLightColor"
            display={['none', 'none', 'none', 'flex']}
            fontSize="xsmall"
            verticalAlign="middle"
          >
            {bookingConfirmationId ? `#${bookingConfirmationId}` : 'No Confirmation ID'}
          </Text>

          <CampaignsBadge publicationBooking={publicationBooking} />

          <ApprovedArtworksBadge artworkCounts={artworkCounts} />

          <Link
            greyLink
            onClick={() => managePublicationBooking()}
            textProps={{ marginLeft: 'medium' }}
          >
            <FontAwesomeIcon icon={faPencil} />
          </Link>
        </Box>
      </Box>
    </ListItem>
  )
}

export default BookingListItem
